'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'location-xmark';
var width = 384;
var height = 512;
var aliases = ["map-marker-times","map-marker-xmark"];
var unicode = 'f60e';
var svgPathData = 'M16 188.6C16 93.5 94.5 16 192 16S368 93.5 368 188.6c0 55-28 117.3-63.9 174.2-35.6 56.3-77.5 104.9-102.2 131.8-5.5 6-14.3 6-19.7 0-24.8-26.9-66.7-75.5-102.3-131.8-35.9-56.8-63.9-119.2-63.9-174.2zM192 0C86 0 0 84.4 0 188.6 0 307.9 120.2 450.9 170.4 505.4 182.2 518.2 201.8 518.2 213.6 505.4 263.8 450.9 384 307.9 384 188.6 384 84.4 298 0 192 0zM126.8 245.8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l53.8-53.8 53.8 53.8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-53.8-53.8 53.8-53.8c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-53.8 53.8-53.8-53.8c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l53.8 53.8-53.8 53.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLocationXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;